module.exports = __webpack_public_path__ + "img/soccerboard72.48c84165.jpg";